import { useState } from "react";
import { useAudioEnabled } from "../../../hooks/media";
import { StatelessToggle } from "../../common/Toggle";
import classNames from "../../common/dialogs/ConfirmActionDialog.module.css";
import RadixDialog from "../../common/dialogs/RadixDialog";
import Button from "../../common/Button";
import MicToggle from "../../common/MicToggle";

const ToggleMicDialog = (props: { title: string; description: string }) => {
  const [open, setOpen] = useState(false);
  const [audioEnabled] = useAudioEnabled();

  return (
    <RadixDialog
      title={props.title}
      open={open}
      onOpenChange={setOpen}
      trigger={
        <button>
          <StatelessToggle enabled={audioEnabled} />
        </button>
      }
      content={
        <div className={classNames.Content}>
          <h3>{props.description}</h3>
          <div className={classNames.Buttons}>
            <Button
              color="gray"
              backgroundColor="black"
              borderColor="dark-gray"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <MicToggle
              className={classNames.MicToggle}
              initialState={audioEnabled}
              toggle={!audioEnabled ? "Start" : "Stop"}
              onChange={(enabled) => {
                if (enabled !== audioEnabled) {
                  setOpen(false);
                }
              }}
            />
          </div>
        </div>
      }
    />
  );
};

export default ToggleMicDialog;
